import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';

import parentStyles from '../../OrderPayment.module.scss';
import { formatMinutesSeconds } from '../../utils';

interface PaymentInProgressProps {
  remainingMs: number;
  isLowTime: boolean;
}

export const PaymentInProgress = ({
  remainingMs,
  isLowTime,
}: PaymentInProgressProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type="timer" size={48} className={parentStyles.timerIcon} />
      <h1>{t('paymentExecution')}</h1>
      <p>{formatMinutesSeconds(remainingMs)}</p>
      {isLowTime && (
        <p className={parentStyles.lowTimeWarning}>
          {t('paymentLowTimeWarning')}
        </p>
      )}
    </>
  );
};
